import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
  name: "newlines"
})
export class NewlinesPipe implements PipeTransform {
  regex = /\n/g

  transform(value: any, args?: any): any {
    if (value && value.replace) {
      return value.replace(this.regex, "<br/>")
    }
    return null
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/newlines.pipe.ts